var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { Provinces } from '../app-config.constants';
import { Helper } from '../classes/helper';
/**
 * A service for checking whether a postal code is targetted for advertising
 * Note that data is stored in a format that minimizes file size by grouping to avoid repeating data
 */
var AdPostalCodeService = /** @class */ (function () {
    function AdPostalCodeService(http) {
        this.http = http;
        // set up observable to process the JSON once and share that replay with future subscribers (cache for life of the service)
        this.postalCodeMap$ = this.http.get(this.getPostalCodeFileEndpoint())
            .pipe(map(function (data) {
            var postalCodes = new Map();
            var _loop_1 = function (target) {
                var _loop_2 = function (province) {
                    data[target][province]['FSAs'].forEach(function (fsa) {
                        var currentValue = postalCodes.get(fsa);
                        // handle multiple target types for one postal code
                        if (currentValue !== undefined) {
                            postalCodes.set(fsa, { province: province, target: currentValue.target.concat(target) });
                        }
                        else {
                            postalCodes.set(fsa, { province: province, target: [target] });
                        }
                    });
                };
                for (var province in data[target]) {
                    _loop_2(province);
                }
            };
            for (var target in data) {
                _loop_1(target);
            }
            ;
            return postalCodes;
        }), shareReplay(1), catchError(function () { return of(new Map()); }));
    }
    // return a promise that resolves to the postal code's province
    AdPostalCodeService.prototype.getProvince = function (postalCode) {
        return __awaiter(this, void 0, void 0, function () {
            var provinceShort, province;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPostalCodeData(postalCode)
                            .then(function (postalCodeData) { return postalCodeData ? postalCodeData.province : null; })];
                    case 1:
                        provinceShort = _a.sent();
                        province = Provinces.find(function (p) { return p.short === provinceShort; });
                        return [2 /*return*/, province ? Helper.replaceWhitespace(province.long, '') : null];
                }
            });
        });
    };
    // return a promise that resolves to the postal code's target
    AdPostalCodeService.prototype.getTarget = function (postalCode) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPostalCodeData(postalCode)
                            .then(function (postalCodeData) { return postalCodeData ? postalCodeData.target : null; })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AdPostalCodeService.prototype.getPostalCodeData = function (postalCode) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postalCodeMap$.toPromise().then(function (postalCodes) { return postalCodes.get(_this.getFSA(postalCode)); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // get the 3 char FSA from a postal code
    AdPostalCodeService.prototype.getFSA = function (postalCode) {
        if (postalCode.length < 3)
            return postalCode;
        return postalCode.substring(0, 3);
    };
    AdPostalCodeService.prototype.getPostalCodeFileEndpoint = function () {
        return Helper.getStaticPathForResource('/assets/json/bell/ad-postal-codes-v1.json');
    };
    return AdPostalCodeService;
}());
export { AdPostalCodeService };
